/**
 * Typed environment access for the frontend.
 *
 * Per docs/ARCHITECTURE.md §2.9: this app never holds secrets. Everything
 * read here is a public, client-safe value (Vite enforces this by only
 * exposing VITE_-prefixed variables to client code in the first place).
 *
 * Validated once, at module load (i.e. at app boot), rather than failing
 * lazily wherever `import.meta.env.VITE_X` first gets read — a missing
 * required variable should be an immediate, obvious startup error.
 */

interface AppEnv {
  apiBaseUrl: string;
}

function readRequired(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${key}. ` +
        `Copy apps/web/.env.example to apps/web/.env.local and fill it in.`,
    );
  }
  return value;
}

export const env: AppEnv = {
  apiBaseUrl: readRequired('VITE_API_BASE_URL'),
};
